import { useState, useEffect, useRef } from 'react'
import { FormattedMessage } from 'components/Commons/Translation'
import useTranslate from 'hooks/useTranslate'

import ReactPortal from 'components/Commons/ReactPortal'

import { Overlay, Tooltip, ContentWrapper, ButtonContainer, Confirmation, Button } from './styled'

import translations from './translations'

const SHAKE_TIMEOUT = 800

function Content({ color, isOpen, onValidate, onReject, message, dataTestId }) {
  return (
    <>
      {isOpen && (
        <ReactPortal id="hb-tooltip-overlay">
          <Overlay onClick={e => e.stopPropagation()} />
        </ReactPortal>
      )}
      <ContentWrapper data-testid={dataTestId}>
        <Confirmation>{message ? message : <FormattedMessage {...translations.confirmation} />}</Confirmation>
        <ButtonContainer>
          <Button size="xs" color="secondary" onClick={onReject} dataTestId="tooltip_confirmation_reject">
            <FormattedMessage {...translations.no} />
          </Button>
          <Button size="xs" color={color} onClick={onValidate} dataTestId="tooltip_confirmation_validate">
            <FormattedMessage {...translations.yes} />
          </Button>
        </ButtonContainer>
      </ContentWrapper>
    </>
  )
}

function ConfirmationTooltip({
  children,
  color,
  isOpen,
  onValidate,
  onReject,
  direction = 'up-middle',
  message: messageIntl,
  dataTestId,
}) {
  const [shake, setShake] = useState(false)
  const timeoutId = useRef()
  const translate = useTranslate()
  const message = translate(messageIntl)

  function onClickOutside() {
    setShake(true)
    timeoutId.current = setTimeout(() => {
      setShake(false)
    }, SHAKE_TIMEOUT)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId.current)
    }
  }, [])

  return (
    <Tooltip
      content={
        <Content
          dataTestId="tooltip_confirmation"
          color={color}
          isOpen={isOpen}
          onValidate={onValidate}
          onReject={onReject}
          message={message}
        />
      }
      direction={direction}
      useHover={false}
      isOpen={isOpen}
      distance={20}
      onClickOutside={onClickOutside}
      shake={shake}
      dataTestId={dataTestId}
    >
      {children}
    </Tooltip>
  )
}

export default ConfirmationTooltip
